import { createSlice } from '@reduxjs/toolkit'
import { fetchCoinHeistGameDailyStatisticsReport, fetchDashboardReport, fetchHiloGameDailyStatisticsReport, fetchLimboGameDailyStatisticsReport, fetchMineGameDailyStatisticsReport, fetchPlinkoGameDailyStatisticsReport, fetchDiceGameDailyStatisticsReport, fetchCoinFlipGameDailyStatisticsReport, fetchKenoGameDailyStatisticsReport, fetchRouletteGameDailyStatisticsReport } from 'redux-thunk/thunk/Dashboard/dashboard'

const initialState = {
  loading: false,
  report: null,
  dailyStatistics: {
    plinkoGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    limboGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    mineGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    coinHeistDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    hiloGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    diceGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    coinFlipGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    kenoGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    },
    rouletteGameDailyStatistics: {
      totalBets: 0,
      totalBetAmount: 0,
      totalWinAmount: 0,
      averageBetAmount: 0,
      totalProfit: 0,
      maxBetAmount: 0,
      totalWins: 0,
      maxWinAmount: 0,
      totalLost: 0,
      maxLossAmount: 0
    }
  }
}

const gameReportsSlice = createSlice({
  name: 'dashboardSlice',
  initialState,
  reducers: {
    updateDashboardReport: (state, action) => {
      let report = state.report
      if (action.payload?.games) {
        report = {
          ...action.payload,
          games: action.payload.games
        }
      }
      return {
        ...state,
        report
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchDashboardReport.fulfilled, (state, action) => {
        let report = {}
        if (action.payload?.games) {
          report = {
            ...action.payload,
            games: action.payload.games
          }
        }
        return {
          ...state,
          loading: false,
          report
        }
      })
      .addCase(fetchDashboardReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(fetchPlinkoGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchPlinkoGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          plinkoGameDailyStatistics: {
            ...state.plinkoGameDailyStatistics,
            ...action.payload?.plinkoGame
          }
        }
      })
      .addCase(fetchPlinkoGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })

      .addCase(fetchLimboGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchLimboGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          limboGameDailyStatistics: {
            ...state.limboGameDailyStatistics,
            ...action.payload?.limboGame
          }
        }
      })
      .addCase(fetchLimboGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(fetchMineGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchMineGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          mineGameDailyStatistics: {
            ...state.mineGameDailyStatistics,
            ...action.payload?.mineGame
          }
        }
      })
      .addCase(fetchMineGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(fetchCoinHeistGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchCoinHeistGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          coinHeistDailyStatistics: {
            ...state.coinHeistDailyStatistics,
            ...action.payload?.coinHeistGame
          }
        }
      })
      .addCase(fetchCoinHeistGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(fetchHiloGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchHiloGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          hiloGameDailyStatistics: {
            ...state.hiloGameDailyStatistics,
            ...action.payload?.hiloGame
          }
        }
      })
      .addCase(fetchHiloGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(fetchDiceGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchDiceGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          diceGameDailyStatistics: {
            ...state.diceGameDailyStatistics,
            ...action.payload?.diceGame
          }
        }
      })
      .addCase(fetchDiceGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })

      .addCase(fetchCoinFlipGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchCoinFlipGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          coinFlipGameDailyStatistics: {
            ...state.coinFlipGameDailyStatistics,
            ...action.payload?.coinFlipGame
          }
        }
      })
      .addCase(fetchCoinFlipGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })

      .addCase(fetchKenoGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchKenoGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          kenoGameDailyStatistics: {
            ...state.kenoGameDailyStatistics,
            ...action.payload?.kenoGame
          }
        }
      })
      .addCase(fetchKenoGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })

      .addCase(fetchRouletteGameDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchRouletteGameDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          rouletteGameDailyStatistics: {
            ...state.rouletteGameDailyStatistics,
            ...action.payload?.rouletteGame
          }
        }
      })
      .addCase(fetchRouletteGameDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })

  }
})

export const { updateDashboardReport } = gameReportsSlice.actions

export default gameReportsSlice.reducer
